import { render, staticRenderFns } from "./RuleCreateSchemeModal.vue?vue&type=template&id=afffac22&scoped=true&"
import script from "./RuleCreateSchemeModal.vue?vue&type=script&lang=ts&"
export * from "./RuleCreateSchemeModal.vue?vue&type=script&lang=ts&"
import style0 from "./RuleCreateSchemeModal.vue?vue&type=style&index=0&id=afffac22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afffac22",
  null
  
)

export default component.exports